import find from 'lodash-es/find';

/**
 * Checks if object is passed object or if it contains passed object
 */
export function contains(stash: any, needle: any, depthLeft = Infinity): boolean {
    return _contains(stash, needle, depthLeft);
}

function _contains(stash: any, needle: any, depthLeft = Infinity, checkedObjects: Set<any> = new Set()): boolean {
    if (typeof stash !== 'object' || typeof needle !== 'object') {
        return false;
    }
    if (stash === needle) {
        return true;
    }
    if (depthLeft < 1 || checkedObjects.has(stash)) {
        return false;
    }
    checkedObjects.add(stash);
    return !!find(stash, stashValue => _contains(stashValue, needle, depthLeft - 1, checkedObjects));
}
